import DashboardCard from "../../components/dashboard/Card";
import React, { useState, useEffect } from "react";
import { Row, DatePicker, Select } from "antd";
import Chart from "react-apexcharts";
import NewRequest from "../../assets/images/icon/NewRequest.png";
import Closed from "../../assets/images/icon/Closed.png";
import Executed from "../../assets/images/icon/Executed.png";
import Execution from "../../assets/images/icon/Execution.png";
import UnderNegotiation from "../../assets/images/icon/UnderNegotiation.png";
import dayjs from "dayjs";
import RecentContractsAudit from './recentContracts'
import ExpiringContracts from "./expiringContracts";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import ChartExportMenu from "../../components/chart/ChartExportMenu";
import { useTheme } from "../../utils/themeToggle/theme";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;
const { Option } = Select;

function CompanyDashboard() {
  const [contractsCount, setContractsCount] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [customDateRange, setCustomDateRange] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const compnayId = localStorage.getItem("companyId") || comp_id; // Get company ID from localStorage or Redux store
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  const handleBarClick = (event, chartContext, config) => {
    const dataIndex = config.dataPointIndex;
    if (dataIndex === -1) return;

    const monthLabel = monthAbbreviations[dataIndex]; // e.g. "Aug 25"
    navigate("/admin/contracts/executed", {
      state: { label: monthLabel, status: "EXECUTED" },
    });
  };


  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCustomDateRange(null);
    fetchContractsCount();
  };

  const handleCustomDateChange = async (dates) => {
    if (!dates || dates.length !== 2) return;

    setCustomDateRange(dates);

    const startDate = dates[0].format("YYYY-MM-DD"); // ✅ Dayjs format
    const endDate = dates[1].format("YYYY-MM-DD");

    try {
      const response = await axiosInstance.post(`/dashboard/executed_agreement_count/`, {
        start_date: startDate,
        end_date: endDate,
        company_id: compnayId
      });

      setContractsCount(response.data.data);
    } catch (error) {
      console.error("Error fetching filtered contract count", error);
    }
  };

  const fetchContractsCount = async () => {
    try {
      const response = await axiosInstance.post(`/dashboard/executed_agreement_count/`, { company_id: compnayId });
      setContractsCount(response.data.data);
    } catch (error) { }
  };
  useEffect(() => {
    fetchContractsCount();
  }, []);

  const monthAbbreviations =
    Array.isArray(contractsCount) && contractsCount.length > 0
      ? contractsCount.slice(0, selectedFilter || 3).map((entry) => {
        const monthAbbrev = entry?.month_name?.slice(0, 3) || "";
        const yearLastTwoDigits = entry?.year?.toString().slice(-2) || "";
        return `${monthAbbrev} ${yearLastTwoDigits}`;
      })
      : [];

  const dataCount =
    Array.isArray(contractsCount) && contractsCount.length > 0
      ? contractsCount
        .slice(0, selectedFilter || 3)
        .map((entry) => entry?.count || 0)
      : [];

  const maxDataValue = Math.max(...dataCount);
  const yaxisOptions = {
    max: maxDataValue < 10 ? 10 : maxDataValue,
  };

  const state = {
    series: [
      {
        name: "Executed Contracts",
        data: dataCount,
      },
    ],
    options: {
      chart: {
        type: "bar",
        zoom: {
          enabled: false,
        },
        events: {
          dataPointSelection: handleBarClick, 
        },

        events: {
          dataPointSelection: (event, chartContext, config) => {
            const index = config.dataPointIndex;
            const selected = contractsCount[index]; 
            if (!selected) return;

            const { month_name, year } = selected;

            navigate("/admin/contracts", {
              state: {
                month_name,
                year,
                company_id: compnayId,
                status: "EXECUTED", 
              },
            });
          },
        },
        dropShadow: {
          enabled: false,
        },
        toolbar: {
          show: false,
          tools: {
            download: true,
          },
          export: {
            csv: {
              filename: "Executed-Contracts-Summary",
            },
            svg: {
              filename: "Executed-Contracts-Chart",
            },
            png: {
              filename: "Executed-Contracts-Chart",
            },
          },
        },
      },
      xaxis: {
        show: true,
        categories: monthAbbreviations,
        labels: {
          style: {
            colors: darkMode ? "#ffffff" : "#17153B", 
            fontSize: "12px",
            fontWeight: 500,
          },
        },

      },
      yaxis: {
        ...yaxisOptions,
        labels: {
          style: {
            colors: darkMode ? "#ffffff" : "#17153B", 
            fontSize: "10px",
            fontWeight: 500,
          },
        },
      },
      grid: {
        show: true,
        borderColor: darkMode ? "gray" : "#E6E6E7", 
        strokeDashArray: 0,
        xaxis: {
          lines: {
            show: false, 
          },
        },
        yaxis: {
          lines: {
            show: true, 
          },
        },
      },
      title: {
        text: "No. of Executed Contracts",
        style: {
          fontSize: "15px",
          fontWeight: "bold",
          color: darkMode ? "#ffffff" : "#17153B",
        },
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      plotOptions: {
        bar: {
          distributed: false,
          endingShape: "flat", 
        },
      },
      colors: ["#fde68a"],
    },
  };


  const allAgreementCounts = async () => {
    try {
      const company_id = localStorage.getItem("companyId") || comp_id;
      console.log("Company ID:", company_id);
      const response = await axiosInstance.post(`/dashboard/agreement_count/`, { company_id: company_id });
      setStatusData(response.data.data);
    } catch (error) { }
  };
  useEffect(() => {
    allAgreementCounts();
  }, []);

  const disabledDate = (current) => {
    const today = dayjs().endOf("day"); 
    return current && current > today;
  };

  return (
    <div className="">
      <div className="h-[100%] bg-white dark:bg-[#17153B] p-4 ">
        <div className="mb-4 ">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-5 ">
            <DashboardCard
              bgColor="bg-sky-200 dark:border-white border-[1px]  dark:bg-[#1E3A8A]"
              icon={NewRequest}
              to="/admin/contracts/agreement_type/fresh_request/"
              text="Fresh Request"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.FRESH_REQUEST
              }
              total={
                statusData && statusData.count && statusData.count.FRESH_REQUEST
              }
            />

            <DashboardCard
              bgColor="bg-orange-100 dark:border-white border-[1px]  dark:bg-[#92400E]"
              icon={UnderNegotiation}
              to="/admin/contracts/agreement_type/under_negotiation/"
              text="Under Negotiation"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.UNDER_NEGOTIATION
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.UNDER_NEGOTIATION
              }
            />

            <DashboardCard
              bgColor="bg-teal-100 dark:border-white border-[1px]  dark:bg-[#134E4A]"
              icon={Execution}
              to="/admin/contracts/agreement_type/under_execution/"
              text="Under Execution"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.UNDER_EXECUTION
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.UNDER_EXECUTION
              }
            />

            <DashboardCard
              bgColor="bg-lime-100 dark:border-white border-[1px]  dark:bg-[#365314]"
              icon={Executed}
              to="/admin/contracts/agreement_type/executed/"
              text="Executed"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.EXECUTED
              }
              total={
                statusData && statusData.count && statusData.count.EXECUTED
              }
            />

            <DashboardCard
              bgColor="bg-red-200 dark:border-white border-[1px]  dark:bg-[#7F1D1D]"
              icon={Closed}
              to="/admin/contracts/agreement_type/transaction_closed/"
              text="Transaction Cancelled"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.TRANSACTION_CLOSED
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.TRANSACTION_CLOSED
              }
            />
          </div>
        </div>

        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div id="executed-contracts" className="  dark:border-white border-[1px]  rounded-lg pl-[1px]">
            <div className="bg-white dark:bg-[#17153B]  flex flex-col rounded-t-lg">
              <div className="ml-4 flex flex-row justify-between items-left mb-2 mt-2 rounded-t-lg">
                <RangePicker
                  onChange={handleCustomDateChange}
                  value={customDateRange}
                  disabledDate={disabledDate}
                  className="pr-4 dark:bg-[#17153B] dark:text-white dark:border-gray-600"
                />
                <Select
                  defaultValue="3"
                  onChange={handleFilterChange}
                  style={{ width: "100px" }}
                  className="mx-4 dark:text-white"
                >
                  <Option value="3">3 Months</Option>
                  <Option value="6">6 Months</Option>
                  <Option value="12">1 Year</Option>
                </Select>

              </div>

            </div>
            <div className={`${state.rounded} px-1 bg-slate-50 dark:bg-[#17153B] rounded-b-lg`}>
              <div className="relative h-full">

                <div className=" absolute top-0 right-0 z-10">
                  <ChartExportMenu chartId="executed-contracts" pdfName="Executed contracts" csvData={dataCount} />
                </div>
                <Chart
                  options={state.options}
                  series={state.series}
                  type="bar"
                  height={230}
                  {...state.additionalProps}
                />
              </div>

            </div>
            {/* Other charts go here */}
          </div>
          <ExpiringContracts />
        </div>
        <RecentContractsAudit />
      </div>
    </div>
  );
}

export default CompanyDashboard;
